<template>
  <div class="soar-container flex flex-col gap-y-3">
    <div class="w-full flex flex-col md:flex-row gap-3">
      <div class="flex-1 bg-brand-gray-150 p-2 rounded-md">
        <p class="text-xs ltr:font-sans">{{ $t('serviceVisaForGuest') }}</p>
      </div>
      <div class="p-2">
        <RouterLink
          :to="{ name: 'PublicVisaApplicationTracking' }"
          class="rounded-full bg-primary px-4 py-1 md:py-1.5 text-white text-center text-lg md:text-md hover:bg-primary-700"
        >
          {{ $t('applicationTrackingMenu') }}
        </RouterLink>
      </div>
    </div>

    <div class="w-full flex items-center text-sm md:text-base">
      <router-link
        :class="{ 'text-primary': matchedRoute.includes('/services/public-visa/issue-new') }"
        class="py-0.5 md:py-2 px-1.5 md:px-3 hover:bg-brand-gray-150"
        to="/services/public-visa/issue-new"
      >
        {{ $t('issueNewVisa') }}
      </router-link>
      <div class="w-2 h-5 mb-1 border-e border-brand-gray-600"></div>
      <router-link
        :class="{ 'text-primary': matchedRoute.includes('/services/public-visa/extension') }"
        class="py-0.5 md:py-2 px-1.5 md:px-3 hover:bg-brand-gray-150"
        to="/services/public-visa/extension"
      >
        {{ $t('extensionVisa') }}
      </router-link>
      <div class="w-2 h-5 mb-1 border-e border-brand-gray-600"></div>
      <router-link
        :class="{ 'text-primary': matchedRoute.includes('/services/public-visa/modification') }"
        class="py-0.5 md:py-2 px-1.5 md:px-3 hover:bg-brand-gray-150"
        to="/services/public-visa/modification"
      >
        {{ $t('modificationVisa') }}
      </router-link>
      <div class="w-2 h-5 mb-1 border-e border-brand-gray-600"></div>
      <router-link
        :class="{ 'text-primary': matchedRoute.includes('/services/public-visa/cancellation') }"
        class="py-0.5 md:py-2 px-1.5 md:px-3 hover:bg-brand-gray-150"
        to="/services/public-visa/cancellation"
      >
        {{ $t('cancellationVisa') }}
      </router-link>
      <div class="w-2 h-5 mb-1 border-e border-brand-gray-600"></div>
      <router-link
        :class="{
          'text-primary': matchedRoute.includes('/services/public-visa/pre-entry-extension')
        }"
        class="py-0.5 md:py-2 px-1.5 md:px-3 hover:bg-brand-gray-150"
        to="/services/public-visa/pre-entry-extension"
      >
        {{ $t('preEntryExtensionVisa') }}
      </router-link>
    </div>

    <router-view></router-view>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const matchedRoute = computed(() => {
  return route.matched.map((m) => m.path)
})
</script>

<script>
export default { name: 'PublicvisaRouter' }
</script>

<style lang="scss" scoped></style>
